<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" tableTitle="入会申请" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th class="operation-th">操作</th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td>
              <div class="operation-btn-div">
                <template v-if="props.item.state !== 1">
                  <span class="cursor-el" @click="onPassItem(props.item)">通过</span>
                  <span class="cursor-el" @click="onDelItem(props.item)">删除</span>
                </template>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../components/TableBox";
import {getFirmMemberApplyJoins, postFirmApplyJoinPass, postFirmApplyJoinDel} from "../common/api";

export default {
  name: "ApplyJoins",
  components: { TableBox },
  data() {
    return {
      action: getFirmMemberApplyJoins,
      reloadData: false,
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "姓名", name: "name", title: "name", isHtml: false, value: this.getObjValue },
        { state: true, alias: "电话", name: "phone", title: "phone", isHtml: false, value: this.getObjValue },
        { state: true, alias: "单位", name: "companyName", title: "companyName", isHtml: false, value: this.getObjValue },
        { state: true, alias: "状态", name: "state", title: "state", isHtml: true, value: this.getObjValue },
        { state: true, alias: "时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    tableFieldNum() {
      let num = 1;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      if(field === "state"){
        return item[field] === 1 ? "<span class='success-txt'>通过</span>" : "<span class='red-txt'>待审核</span>";
      }else{
        return item[field];
      }
    },
    onReloadData() {
      this.reloadData = true;
    },
    onPassItem(item) {
      this.$layer.confirm(`是否通过【${item.name}】的申请？`, layerid => {
        postFirmApplyJoinPass({ id: item.id })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    },
    onDelItem(item) {
      this.$layer.confirm(`是否删除(拒绝)【${item.name}】的申请？`, layerid => {
        postFirmApplyJoinDel({ id: item.id })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #f7f7fa;
    padding: 30px 20px 10px 20px;
    .operation-th {
      width: 110px;
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>